import { Component, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from './_services/settings.service';
import { Router } from '@angular/router';
import { VersionService } from './_services/version.service';
import { catchError, first, interval, Subject, switchMap, take, takeUntil } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'terminal';

  private _subject = new Subject<void>();

  constructor(
    private settingsService: SettingsService,
    private versionService: VersionService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (!this.settingsService.isSetupDone) {
      this.router.navigate(['/setup']);
    }

    interval(this.settingsService.updateInterval) // 60 minutes
      .pipe(switchMap(() => this.versionService.isCurrentVersion()))
      .pipe(takeUntil(this._subject))
      .pipe(
        catchError((error) => {
          console.error('Error checking version:', error);
          return [true]; // in case of error, assume current version
        })
      )
      .subscribe((isCurrentVersion) => {
        if (!isCurrentVersion) {
          console.log('New version available, reloading...');
          window.location.reload();
        } else {
          console.log('Application is up to date.');
        }
      });
  }

  ngOnDestroy(): void {
    this._subject.next();
    this._subject.complete();
  }
}
